import Typography from "@mui/material/Typography";
const Footer = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography
        variant="subtitle1"
        color="primary"
        style={{ padding: "10px 0" }}
      >
        &copy;CarBazar
      </Typography>
    </div>
  );
};

export default Footer;
